import AccountCreation from "@/components/signup/account-creation";
import { LoomOverlayTemplate } from "@/components/signup/layouts";
import { experiments, ExperimentView } from "@/utils/experiment";

import {
    InputSubmitButton,
    GetStartedHeading,
    SignupDefault
} from "../../components";
import { FreeSubheading } from "../components/free-subheading";

export const LoggedOutLoom = ({
    shouldForceOverlayView
}: {
    shouldForceOverlayView?: boolean;
} = {}) => {
    if (shouldForceOverlayView) {
        return (
            <LoomOverlayTemplate size="sm">
                <Content />
            </LoomOverlayTemplate>
        );
    }

    return (
        <ExperimentView
            experiment={experiments.gwp7282loomlofisignup}
            render={(value) => {
                return value ? (
                    <LoomOverlayTemplate size="sm">
                        <Content />
                    </LoomOverlayTemplate>
                ) : (
                    <SignupDefault />
                );
            }}
        />
    );
};

const Content = () => (
    <>
        <GetStartedHeading productName="Loom" />
        <FreeSubheading />
        <AccountCreation Input={<InputSubmitButton />} Submit={null} />
    </>
);
